import React, { Component } from 'react';
import {
    Text,
    Spinner,
    Icon,
    Modal,

} from '@shopify/polaris';
import {

} from '@shopify/polaris-icons';
import Language from '../../../../i18n/Language';
import VsIcon from '../../../../assets/VsIcon';

const t = Language;

class ImageCompareModal extends Component {
    state = {
        isShowCompareImage: this.props.isShowCompareImage,    // 弹窗状态
        imageModalLoading: this.props.imageModalLoading,      // 弹窗loading
        viewData: this.props.viewData,                        // 对比数据
        type: this.props.type                                 // 表格类型
    }

    componentDidMount() {

    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.isShowCompareImage !== this.props.isShowCompareImage) {
            this.setState({
                isShowCompareImage: nextProps.isShowCompareImage,

            })
        }
        if (nextProps.imageModalLoading !== this.props.imageModalLoading) {
            this.setState({
                imageModalLoading: nextProps.imageModalLoading,
            })
        }
        if (nextProps.viewData !== this.props.viewData) {
            this.setState({
                viewData: nextProps.viewData,
                type: nextProps.type,
            })
        }

        return true;
    }

    // 关闭弹窗
    closeModal = () => {
        this.props.closeImageCompare();
    }


    render() {
        const {
            isShowCompareImage,
            imageModalLoading,
            viewData,
            type,

        } = this.state;

        // 图片对比弹窗
        const ImageCompareModal = <Modal
            size='large'
            open={isShowCompareImage && Object.keys(viewData).length > 0}
            title={t("Compress images without losing quality")}
            onClose={this.closeModal}
        >
            {
                imageModalLoading ? <div className='flex_layout image_loading'><Spinner /></div> : null
            }
            <div className='compare_image_modal'>
                <div className='left'>
                    <div className='red_original'>{t("Original")}</div>
                    {
                        type === 'public' ? <img src={viewData?.image?.before_file_path} alt='test'></img> : 
                        type === 'other' ? <img src={viewData.before_file_path} alt='test'></img> : 
                        <img src={viewData?.before_file_path} alt='test'></img>
                    }
                    <div className='flex_layout size_compare'>
                        <Text variant="headingMd" as="h2">{t("Filesize")}</Text>
                        <span style={{ color: '#E50300' }}>
                            {
                                type === 'public' ? changeBitInfo(viewData?.image?.img_size) : 
                                type === 'other' ? changeBitInfo(viewData.img_size) : changeBitInfo(viewData?.img_size)
                            }
                        </span>
                    </div>
                </div>
                <div className='mid'>
                    <Icon source={VsIcon} />
                </div>
                <div className='right'>
                    <div className='green_opt'>{t("Optimized")}</div>
                    {
                        type === 'public' ? <img src={viewData?.image?.after_file_path} alt='test'></img> : 
                        type === 'other' ? <img src={viewData.after_file_path} alt='test'></img> : 
                        <img src={viewData?.after_file_path} alt='test'></img>
                    }
                    <div className='flex_layout size_compare'>
                        <Text variant="headingMd" as="h2">{t("Filesize")}</Text>
                        <span style={{ color: '#008060' }}>
                            {
                                type === 'public' ? changeBitInfo(viewData?.image?.comp_size) : 
                                type === 'other' ? changeBitInfo(viewData.comp_size) : changeBitInfo(viewData?.comp_size)
                            }
                        </span>
                    </div>
                </div>
            </div>
        </Modal>

        return ImageCompareModal;
    }
}

// 比特转换
function changeBitInfo(limit) {
    let size = "";
    if (limit < 1 * 1024 * 1024) {
        //小于0.1MB，则转化成KB 
        size = (limit / 1024).toFixed(2) + "KB"
    } else if (limit < 1 * 1024 * 1024 * 1024) {
        //小于0.1GB，则转化成MB 
        size = (limit / (1024 * 1024)).toFixed(2) + "MB"
    } else {
        //其他转化成GB 
        size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB"
    }
    return size;
}

export default ImageCompareModal;

